export function createImageFromBase64(base64Image) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            const { width, height } = img;

            const originalCanvas = createCanvas(width, height);
            drawImageOnCanvas(originalCanvas, img);

            resolve(originalCanvas.toDataURL('image/jpeg'));
        };
        img.onerror = () => reject(new Error('Failed to load the image'));
        img.src = base64Image;
    });
}
export async function base64ToBlob(dataURL) {
    try {
    const [header, base64String] = dataURL.split(',');
    const mimeType = header.match(/:(.*?);/)[1];
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    return new Blob([byteArray], { type: mimeType });
    } catch (error) {
    console.error('Error al convertir Base64 a Blob:', error);
    throw error;
    }
}
export function cropImageFromGuide (video, overlay) {
    const canvas = document.createElement('canvas')

    const videoRect = video.getBoundingClientRect();
    const overlayRect = overlay.getBoundingClientRect();

    const scaleX = video.videoWidth / videoRect.width;
    const scaleY = video.videoHeight / videoRect.height;

    const overlayX = (overlayRect.left - videoRect.left) * scaleX;
    const overlayY = (overlayRect.top - videoRect.top) * scaleY;
    const overlayWidth = overlayRect.width * scaleX;
    const overlayHeight = overlayRect.height * scaleY;

    canvas.width = overlayWidth;
    canvas.height = overlayHeight;
    const context = canvas.getContext('2d');

    context.drawImage(video, overlayX, overlayY, overlayWidth, overlayHeight, 0, 0, overlayWidth, overlayHeight);
    return canvas.toDataURL('image/jpeg');
};

export function createCanvas(width, height) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
}
export function drawImageOnCanvas(canvas, image, x = 0, y = 0) {
    const context = canvas.getContext('2d');
    context.drawImage(image, x, y, canvas.width, canvas.height);
    return context;
}